// extracted by mini-css-extract-plugin
module.exports = {"Param":"Param_Param__rzZ41","ParamLabel":"Param_ParamLabel__nxMjL","ParamValue":"Param_ParamValue__1CRhD","BtnCopy":"Param_BtnCopy__mZ1fo"};